import Cleave from 'cleave.js'

export function cleaveInstance(selector, valueChangedFn = () => {}) {
  const delimiter = this.settings.thousand_separator
  const element = document.querySelector(selector)

  return new Cleave(element, {
    numeral: true,
    numeralDecimalMark: this.settings.decimal_separator,
    delimiter: delimiter === 'space' ? ' ' : delimiter,
    numeralDecimalScale: this.decimals,
    onValueChanged: valueChangedFn
  })
}
